<template>
  <GlobalAlertWindow
    v-loading="isUploading"
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" label-width="120px" label-suffix="："  inline>
      <el-form-item label="备注" prop="sysInfo">
        <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 12}" v-model="form.sysInfo" placeholder="请输入备注" :maxlength="5" v-trim/>
      </el-form-item>
      
    </el-form>
  </GlobalAlertWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalAlertWindow from '@/components/common/GlobalAlertWindow'
export default {
  name: 'OperaOrderMarkWindow',
  extends: BaseOpera,
  components: { GlobalAlertWindow },
  data () {
    return {
      isUploading: false,
      // 表单数据
      form: {
        id: null,
        sysInfo: ''
        // isdeleted: '',
        // name: '',
        // info: '',
        // type: '',
        // module: '',
        // parentId: '',
        // sortnum: '',
        // status: '',
        // imgurl: ''
      }
    }
  },
  
  created () {
    this.config({
      api: '/business/labels',
      'field.id': 'id'
    })
    
  },
  
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/alertstyle.scss";


</style>
